import config from './config';
import { map, split, join, replace, find, isNil } from 'lodash';
import { ServiceSettings } from '@/enums';
import { differenceInYears, format } from 'date-fns';
import { MIN_AGE_TO_BOOK_IN_APP, APPOINTMENT_FOR_SOMEONE_ELSE } from '@/config';
import { TrimozError } from '@trimoz/trimoz-vue-error-handling';

export function dateTimeToString(date) {
    // date must be '2018-06-10T12:00:00.000-04:00'
    if (date) {
        return date.substr(0, 10) + ' ' + date.substr(11, 8);
    }
    return null;
}

export function formatTimefromJsDate(date) {
    // eslint-disable-next-line
    if(!(date instanceof Date)) {
        const parse = require('date-fns/parse');
        date = parse(date);
    }
    let hour = date.getHours();
    let min = date.getMinutes();

    hour = hour < 10
        ? '0' + hour
        : hour;

    min = min < 10
        ? '0' + min
        : min;

    return hour + ':' + min;
}

export function formatDatefromJsDate(date) {
    // Warning: Do not send the time with the date, only date
    // eslint-disable-next-line
    if(!(date instanceof Date)) {
        const parse = require('date-fns/parse');
        date = parse(date);
    }
    let month = '' + (date.getMonth() + 1);
    let day = '' + date.getDate();
    let year = date.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

export function stringDate(date, lang) {
    const parse = require('date-fns/parse');
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return parse(date + ' 12:00').toLocaleDateString(lang + '-CA', options);
}

export function formatPhoneNumber(s) {
    let m = s.match(/^(\d{3})(\d{3})(\d{4})(.*)$/);
    return (!m) ? null : m[1] + '-' + m[2] + '-' + m[3] + m[4];
}

export function getEachDaysElements(viewType) {
    if(viewType === 'month') {
        return document.querySelectorAll('td:not(.fc-other-month) > .fc-day-number');
    }
    else if(viewType === 'agendaWeek') {
        return document.querySelectorAll('.fc-day-header');
    }
    return false;
}

export function shadeColor(color, percent) {
    let f = parseInt(color.slice(1), 16);
    let t = percent < 0 ? 0 : 255;
    let p = percent < 0 ? percent * -1 : percent;
    let R = f >> 16;
    let G = f >> 8 & 0x00FF;
    let B = f & 0x0000FF;
    return '#' + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}

export function placeHasAvailabilities(events, date, placeId, has) {
    return has(events, date) && events[date][placeId];
}

export function setProduct(domain) {
    let product = 'clicsante';
    if (process.env.VUE_APP_ENV === 'development') product = process.env.VUE_APP_PRODUCT;
    else if (domain.search('pharmaprix') !== -1) product = 'pharmaprix';
    else if (domain.search('uniprix') !== -1) product = 'uniprix';
    else if (domain.search('pharmaservices') !== -1) product = 'pharmaservices';
    else if (domain.search('reacts') !== -1) product = 'reacts';
    return product;
}

/**
 * Overriding favicon complete. Firefox loads the last favicon it sees in webpack regardless of head tags. And since
 * pharmaservice is dying anyway, we'll just remove it soon so we hardcode this to clic-sante.
 */
export function setFavicon() {
    let searchString = 'favicon-clicsante';
    let x = document.querySelectorAll('link');
    for (let i = 0; i < x.length; i++) {
        let str = x[i].href;
        let str2 = x[i].rel;
        if (str.search(searchString) === -1 && str2 !== 'stylesheet') {
            x[i].remove();
        }
    }
}

export function getGoogleTagManager(product) {
    if (process.env.VUE_APP_ENV === 'production' && config[product]) {
        return config[product].GTM;
    }
    // Non-production environment, return GTM dev clicsante account number
    return process.env.VUE_APP_GTM_TAG;
}

/**
 * Calculate distance between two locations in a straight line
 * @params lat1, lng1, lat2, lng2
 */
export function distanceBetweenLocation(lat1, lng1, lat2, lng2) {
    // $earthRadius = 3958.75; //in miles, change to 6371 for kilometer
    const earthRadius = 6371;

    const degLat = deg2rad(lat2 - lat1);
    const degLng = deg2rad(lng2 - lng1);
    const sindLat = Math.sin(degLat / 2);
    const sindLng = Math.sin(degLng / 2);

    const ret1 = Math.pow(sindLat, 2) + Math.pow(sindLng, 2) * Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2));
    const ret2 = 2 * Math.atan2(Math.sqrt(ret1), Math.sqrt(1 - ret1));
    return earthRadius * ret2;
}

export function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

export function formatDateToDatePicker(date) {
    const dateMatch = !isNaN(Date.parse(date)) && date.match(/[0-9]{4}[-][0-9]{1,2}[-][0-9]{1,2}/);
    if (!dateMatch) return null;
    return join(map(split(dateMatch[0], '-'), (d) => {
        return (!/^0/.test(d) && +d < 10 ? '0' : '') + d;
    }), '-');
}

export function maskNam(payload) {
    if (!payload || !payload.replace) {
        return '';
    }
    const regex = new RegExp('[A-Za-z0-9]{4}', 'gi');
    return payload.replace(/\s+/gi, '').replace(regex, '$& ').trim();
}

export function maskPhoneNumber(payload) {
    if (!payload || !payload.replace) {
        return '';
    }

    const unmask = payload.replace(/^[+]1/, '').replace(/[^0-9]/gi, '');
    const parts = unmask.match(/^(\d{1,3})(?:(\d{1,3})|$)(?:(\d{1,4})|$)/);
    let phone = '';
    if (parts && parts[1]) {
        phone = `(${parts[1]}`;
    }
    if (parts && parts[2]) {
        phone += `) ${parts[2]}`;
    }
    if (parts && parts[3]) {
        phone += ` - ${parts[3]}`;
    }
    return phone;
}

export const isUsingKc = process.env.VUE_APP_IS_USING_KEYCLOAK_LOGIN_AUTH === 'true';
export const authModule = isUsingKc ? 'kcAuth' : 'jwt';

export function removeAccents(str) {
    return str ? str.normalize('NFD').replace(/'/g, '').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ') : '';
}

export function retainSTLetters(str) {
    const prefixRegex = /^(?!^SAIN(t|)(e|)$)(ST(e|)|SAINTE?|SAINT?|SAINTE)([ -][a-zA-Z]+)?\b/i;
    const index = str.search(/[\s-]/);

    const [, secondElement] = [str.substring(0, index), str.substring(index + 1).replace(/[\s-]/g, '')];
    return prefixRegex.test(str) ? 'ST' + secondElement : str.replace(/\s/g, '');
}

export function addXForSmallNam(str) {
    return str.length > 2 ? str : str.padEnd(3, 'X');
}

export function removeDash(str) {
    return replace(str, '-', '');
}

export function normalizeLastName(str) {
    let formattedValue = removeAccents(str); // will remove accents, remove consecutive whitespace and diacritical marks
    formattedValue = retainSTLetters(formattedValue);
    formattedValue = removeDash(formattedValue);
    return addXForSmallNam(formattedValue);
}

export function avoidNoAppointmentFocus() {
    const outsideDays = document.querySelectorAll('div.v-calendar-weekly__day.v-outside a, div.v-calendar-weekly__day.v-outside button, div.v-calendar-weekly__day.v-future.v-outside a, div.v-calendar-weekly__day.v-future.v-outside button, div.v-calendar-weekly__day.v-past.v-outside a, div.v-calendar-weekly__day.v-past.v-outside button');
    outsideDays.forEach(element => {
        element.setAttribute('tabindex', '-1');
    });
}

/**
 * Unfocus all.
 * ref.: https://stackoverflow.com/a/29237391
 */
export function blurAll() {
    let tmp = document.createElement('input');
    document.body.appendChild(tmp);
    tmp.focus();
    document.body.removeChild(tmp);
}

/**
 * Detect Firefox browser
 * https://stackoverflow.com/questions/13975976/javascript-execute-code-only-if-it-is-not-google-chrome-browser
 */
export function isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

/**
 * Validate that birthday and nam correspond
 */
export function validateNamAgainstBirthday(clientData) {
    if(!clientData.nam || !clientData.birthday) {
        return null;
    }

    if (clientData.nam && clientData.birthday && format(clientData.birthday, 'YYYY-MM-DD') !== getBirthdayFromNAM(clientData).birthday) {
        throw new TrimozError(new Error(), 'errors.birthdayAndNamAreInvalid');
    }
    return true;
}

export function getBirthdayFromNAM(clientData) {
    if (!clientData.nam) {
        return {
            century: null,
            year: null,
            month: null,
            day: null,
            birthday: null,
        };
    }
    clientData.nam = clientData.nam.replace(/\s+/g, '');

    let century = Number(format(Date.now(), 'YYYY').substring(0, 2)) + 1;
    let year = clientData.nam.substring(4, 6);
    let month = clientData.nam.substring(6, 8);
    let day = clientData.nam.substring(8, 10);

    if (month > 12) {
        month = month - 50;
        if (month < 10) {
            month = '0' + month;
        }
    }

    if(clientData.birthday && format(clientData.birthday, 'YYYY') !== 'Invalid Date') {
        let yearFromBirthday = format(clientData.birthday, 'YYYY');
        century = Number(yearFromBirthday.substring(0, 2)) + 1;
    }
    else {
        /**
         * Handle most cases except 100+ years old which is around 9 500 peoples in Canada has of 2021 (https://www.cbc.ca/news/politics/canadian-centenarians-census-2021-1.6436494).
         * Correspond to 0.0002 % of Canada population (40 500 000 has of 2024).
         */
        if (new Date().getFullYear() - (Number(year) + ((century - 2) * 100)) < 100) {
            century = (century - 1);
        }
    }

    return {
        century,
        year,
        month,
        day,
        birthday: format(`${century - 1}${year}-${month}-${day}`, 'YYYY-MM-DD'),
    };
}

/**
 * Validate minimum age base on service settings
 */
export function validateMinAge(clientData, currentEstSettings) {
    if (!clientData.birthday && !clientData.nam) {
        return null;
    }

    let birthday = clientData.birthday ? format(clientData.birthday, 'YYYY-MM-DD') : null;
    birthday = clientData.nam ? getBirthdayFromNAM(clientData).birthday : birthday;

    if(!birthday || birthday === 'Invalid Date') {
        console.warn('Birthday value is invalid. skipping the validation process...');
        return null;
    }

    const minimumAgePatient = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_PATIENT]);
    const minimumAgeAccompanyingPerson = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_ACCOMPANYING_PERSON]);

    // set the minimum age with patient minimum age
    let validateMinAge = null;
    if (minimumAgePatient.value) {
        validateMinAge = minimumAgePatient.value;
    }

    // set the minimum age with accompanying person minimum age
    if (clientData.accompanyingPerson && minimumAgeAccompanyingPerson.value) {
        if (!validateMinAge || minimumAgeAccompanyingPerson.value < validateMinAge) {
            validateMinAge = minimumAgeAccompanyingPerson.value;
        }
    }

    // set minimum age of patient if priority group is set
    if (clientData.priorityGroup && clientData.priorityGroup !== 'nothing') {
        let minimumAgePriorityGroup = null;
        switch (clientData.priorityGroup) {
            case 'requiresConsent':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_REQUIRES_CONSENT]);
                break;
            case 'schoolWorker':
            case 'publicHealthWorker':
            case 'healthWorker':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_HEALTH_WORKER]);
                break;
            case 'essentialHealthWorker':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_ESSENTIAL_HEALTH_WORKER]);
                break;
            case 'chronicDisease':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_CHRONIC_DISEASE]);
                break;
            case 'handicapped':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_HANDICAPPED]);
                break;
            case 'handicappedAccompagnator':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_HANDICAPPED_ACCOMPAGNATOR]);
                break;
            case 'pregnantWoman':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_PREGNANT_WOMAN]);
                break;
            case 'dayCampWorker':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_DAY_CAMP_WORKER]);
                break;
            case 'genericVaccine.immunocompromised':
                minimumAgePriorityGroup = find(currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_IMMUNOCOMPROMISED]);
                break;
        }
        if (minimumAgePriorityGroup && minimumAgePriorityGroup.value) {
            if (!validateMinAge || minimumAgePriorityGroup.value < validateMinAge) {
                validateMinAge = minimumAgePriorityGroup.value;
            }
        }
    }

    validateMinAge = (clientData.requesterLink !== APPOINTMENT_FOR_SOMEONE_ELSE && validateMinAge < MIN_AGE_TO_BOOK_IN_APP) ? MIN_AGE_TO_BOOK_IN_APP : validateMinAge;

    // validate the minimum age with birthday
    if (!isNil(validateMinAge)) {
        const ageNow = format(new Date(), 'YYYY-MM-DD');
        const diffInYears = differenceInYears(ageNow, birthday);

        if (diffInYears < validateMinAge) {
            throw new TrimozError(new Error(), (validateMinAge === MIN_AGE_TO_BOOK_IN_APP) ? 'errors.validateMinAgeApp' : 'errors.validateMinAge', null, null, [MIN_AGE_TO_BOOK_IN_APP]);
        }
    }

    return true;
}

export function formatFormObject(filteredEntries, convertStart = true) {
    return map(filteredEntries, d => {
        if (convertStart) {
            d.start = format(parseFromTimeZone(d.start, { timeZone: 'UTC' }), 'YYYY-MM-DD HH:mm');
        }
        d.birthday = d.birthday ? format(d.birthday, 'YYYY-MM-DD') : '';
        return d;
    });
}

export function removeHTMLTags(text) {
    return text.replace(/<\/?[^>]+(>|$)/g, '');
}
